import cn from 'clsx'
import {CSSTransition} from 'react-transition-group'
import {Spin} from 'antd'

import './Loader.scss'

interface LoaderProps {
  className?: string
  type?: 'fixed' | 'block'
  show?: boolean
  small?: boolean
}

const classNames = {
  enter: 'LoaderEnter',
  enterActive: 'LoaderEnterActive',
  exit: 'LoaderExit',
  exitActive: 'LoaderExitActive',
}

const addEndListener = (node: HTMLElement, done: () => void) => {
  node.addEventListener('transitionend', done, false)
}

export default function Loader({className, type, show, small}: LoaderProps) {
  const content = (
    <div
      className={cn(
        className,
        'Loader',
        type && `Loader_type_${type}`,
        small && 'Loader_small'
      )}
    >
      <Spin size={type || small ? undefined : 'large'} />
    </div>
  )

  if (type)
    return (
      <CSSTransition<undefined>
        unmountOnExit
        in={show}
        classNames={classNames}
        timeout={200}
        addEndListener={addEndListener}
      >
        {content}
      </CSSTransition>
    )

  return content
}
